module.exports = __webpack_public_path__ + "static/media/fbIcon.01b2f6f5.png";